import { connect } from 'react-redux'
import Component from './component'
import RealityCheck from './messages/realityCheck'
import MessageWithLogin from './messages/messageWithLogin'
import SoundPrompt from './messages/soundPrompt'
import HomePrompt from './messages/homePrompt'
import FreeRound from './messages/freeRound'
import JackpotWon from './messages/jackpotWon'
import QuickSpinPrompt from './messages/quickSpinPrompt'
import GameRestore from './messages/gameRestore'
import { errorClosed, message as _message } from '../redux/actions'
import { MESSAGE_TYPES } from '../redux/constants'

/**
 * This component handles the displaying of popups.
 */
@connect(state => ({ externalErrorHandling: state.base.externalErrorHandling }),
  { errorClosed, setMessage: _message })
export default class PopupMessage extends Component {
  /**
   * Dispatch an errorClosed event with the errorCode ID
   * and close the current popup.
   * @param {number} errorCode - The number ID of the error code.
   * @returns {function()}
   */
  onErrorClose = (errorCode) => {
    return (e) => {
      this.props.errorClosed({ errorCode })
      this.closeMessage(e)
    }
  }

  /**
   * Close the current message, using a callback if one exists.
   */
  closeMessage = (e) => {
    const { message, setMessage } = this.props
    if (message.onClose) { message.onClose() } else { setMessage(null) }
    this.prevent(e)
  }


  /**
   * Prevents propagation of events
   */
  prevent(e) {
    e.preventDefault()
    e.stopPropagation()
    return false
  }

  /**
   * Creates a generic error popup.
   * @returns {*} - DOM element.
   */
  normalError() {
    const { message } = this.props
    const errorMessage = this.t(`error.${message.errorCode}`)
    return (
      <div className={`error errorCode-${message.errorCode}`}>
        <div className="error-message">
          { errorMessage !== `error.${message.errorCode}` ? errorMessage : (message.message || message) }
        </div>
        { message.errorCode && (
          <div className="error-code">
            {`${message.errorCode}`}
          </div>
        )}
        <div className="buttonContainer">
          <button className="error-close" onClick={this.onErrorClose(message.errorCode)}>
            {this.t('realityCheck.ok')}
          </button>
        </div>
      </div>
    )
  }

  customError() {
    const { message } = this.props
    const { errorCode, errorDetails: details } = message

    return (
      <div className={`error errorCode-${message.errorCode}`}>
        <div className="error-message">
          <b>{ details.title }</b>
          <div className="divider" />
          { details.message }
        </div>
        { message.errorCode && (
          <div className="error-code">
            {`${errorCode}`}
          </div>
        )}
        <div className="buttonContainer">
          <button className="error-close" onClick={this.onErrorClose(message.errorCode)}>
            { details.buttontext }
          </button>
        </div>
      </div>
    )
  }

  /**
   * Creates a normal popup, if a specific one does not exist.
   * @returns {*} - DOM element
   */
  createNormal() {
    const { message } = this.props
    return (
      <div className="popup-content" onClick={this.prevent} >
        <div className="popup-message" dangerouslySetInnerHTML={{__html: message.message || message }} />
        <br />
        <div className="buttonContainer">
          <button onClick={this.closeMessage}>{this.t('realityCheck.ok')}</button>
        </div>
      </div>
    )
  }

  render() {
    const { message, externalErrorHandling } = this.props
    const { data, type } = message

    let component

    switch (type) {
      case MESSAGE_TYPES.ERROR:
        component = message.errorDetails ? this.customError() : this.normalError()
        break
      case MESSAGE_TYPES.REALITYCHECK:
        component = <RealityCheck {...{ data }} />
        break
      case MESSAGE_TYPES.MESSAGE_LOGIN:
        component = <MessageWithLogin mess={message.message} errorCode={message.errorCode} />
        break
      case MESSAGE_TYPES.SOUND_PROMPT:
        component = <SoundPrompt />
        break
      case MESSAGE_TYPES.HOME_PROMPT:
        component = <HomePrompt />
        break
      case MESSAGE_TYPES.FREEROUNDS:
        return <FreeRound {...{ message }} />
      case MESSAGE_TYPES.JACKPOT:
        component = <JackpotWon {...{ data }} />
        break
      case MESSAGE_TYPES.QUICKSPIN_PROMPT:
        component = <QuickSpinPrompt />
        break
      case MESSAGE_TYPES.GAME_RESTORE:
        component = <GameRestore />
        break
      default:
        component = this.createNormal()
    }

    if (externalErrorHandling && message.errorCode) {
      return <div/>
    }

    return (
      <div className={`popup  type-${type || 'DEFAULT'}`}>
        { component }
      </div>
    )
  }
}
